import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import IconPaths from "./IconPaths";
import { useTheme } from "@mui/material";

interface IStaticIconProps {
  name: string;
}

const StaticIcon = (props: IStaticIconProps & SvgIconProps) => {
  const { name, ...rest } = props;
  const { palette } = useTheme();
  return (
    <SvgIcon htmlColor={palette.primary.text} {...rest}>
      <path d={IconPaths[name]} fill="inherit" />
    </SvgIcon>
  );
};

export default StaticIcon;
